import BaseActions from '@/store/base/actions'
import Schema from "@/store/modules/smsTemplates/schema";

const module = 'smsTemplates'

export default BaseActions({module}, {
  //
}, [Schema])